import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/layout/Header.tsx';
import { Footer } from '@/components/layout/Footer.tsx';
import { Hero } from '@/components/sections/Hero.tsx';
import { About } from '@/components/sections/About.tsx';
import { Contact } from '@/components/sections/Contact.tsx';
import { ConnectWithUs } from '@/components/sections/ConnectWithUs.tsx';
import { Merchandise } from '@/components/sections/Merchandise.tsx';

export function Index() {

  return (
    <>
      <Helmet>
        <title>Goodspeed Airport</title>
        <meta name="description" content="Welcome to Goodspeed Airport and Seaplane Base" />
        <meta name="author" content="Goodspeed Airport" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#aba6a4" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://goodspeedairport.com/" />
        <meta property="og:site_name" content="Goodspeed Airport" />
        <meta property="og:title" content="Goodspeed Airport" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:image" content="https://i.vimeocdn.com/video/1311374609-1fec9c157e528cc11f5784acaac3274096e524894d95efaa7_1280x720?r=pad" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Goodspeed Airport" />
        <meta name="twitter:description" content="Welcome to Goodspeed Airport and Seaplane Base" />
        <meta name="twitter:image" content="https://i.vimeocdn.com/video/1311374609-1fec9c157e528cc11f5784acaac3274096e524894d95efaa7_1280x720?r=pad" />
        <meta name="twitter:image:alt" content="Goodspeed Airport" />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        <Hero />
        <About />
        <Contact />
        <ConnectWithUs />
        <Merchandise />
        <Footer />
      </div>
    </>
  );
}